




































import { Component, Vue } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import commonService from '@/services/common-services';

@Component
export default class Recharge extends Vue {
  get userInfo() {
    return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
  }
  get configuration() {
    return this.$store.state[APP_CONFIG.stateKey.commonStore].configuration;
  }
  get bankAccounts()  {
    // if (this.configuration && this.configuration.BankAccounts) {
    //     return JSON.parse(this.configuration.BankAccounts);
    // }
    return [ 
      // { "bank_name": "Ngân hàng Vietcombank", "account_name": "NGUYỄN THỊ HỒNG PHƯƠNG", "account_number": "1014524636", "branch": "HÀ THÀNH" },
      { "bank_name": "MB BANK", "account_name": "Nguyen Hoang Thuy Tien", "account_number": "04848 6668 0068", "branch": "" }
    ];
  }
  private async getConfiguration() {
    const result = await commonService.configuration();
    if (result && result.status === 200) {
      (window['getApp'] as any).$emit('SET_CONFIGURATION', result.data.data);
    }
  }
  private async created() {
    if (!this.configuration) {
      await this.getConfiguration();
    }
  }
}
